import React from 'react';
import { roundedNumberFormatter, numberFormatter } from '../formatters/numberFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import JsBarcode from 'jsbarcode';
import moment from 'moment';

const print = async (printData) => {
  const { settingData, userName, journalVoucher, vatAmount, cart, invoiceId, account, delivery, newBalance,
    discountPercentage, currency, ratedTotalPrice, ratedSymbol, isUsingMainCurrency } = printData;

  const createdAt = journalVoucher?.createdAt;
  const date = journalVoucher?.date;

  const generateBarcode = (id) => {
    if (!id) return '';
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, id, { format: 'CODE128', width: 1, height: 40, displayValue: false });
    return canvas.toDataURL();
  };

  const barcodeDataUrl = invoiceId ? generateBarcode(invoiceId) : '';

  // Create or reuse a hidden iframe
  let iframe = document.getElementById('print-frame');
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = 'print-frame';
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
  }

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            @media print {
              @page { margin: 0; }
              body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
            }
            body {
              font-family: Arial, sans-serif;
              color: black;
            }
            .receipt {
              width: 95%;
              margin: auto;
              padding: 12px;
              background: #fff;
            }
            .header {
              text-align: center;
              margin-bottom: 10px;
              border-bottom: 1px solid grey;
              padding-bottom: 10px;
            }
            .header h1 { 
              font-size: 1.4rem;
              margin-bottom: 4px;
              color: black;
            }
            .header p { 
              font-size: 0.9rem;
              margin: 2px 0;
            }
            .details, .items, .summary {
              padding: 10px 0;
              border-bottom: 1px solid grey;
            }
            .account {
              paddingTop: 0px;
              border-bottom: 1px solid grey;
            }
            .detailsAccount {
              display: flex;
              justify-content: space-between;
              font-size: 0.95rem;
              margin-bottom: -15px;
            }
            .detailsFlex {
              display: flex;
              justify-content: space-between;
              font-size: 0.95rem;
              margin-bottom: 5px;
            }
            .table {
              width: 100%;
              font-size: 0.9rem;
              margin-top: 5px;
              border-collapse: collapse;
            }
            .table th, .table td {
              padding: 3px 2px;
              text-align: left;
            }
            .table th {
              font-weight: 600;
              background: #f5f5f5;
            }
            .summary p { margin: 4px 0; }
            .total {
              font-size: 1rem;
              font-weight: 600;
            }
            .footer {
              text-align: center;
              font-size: 0.85rem;
              padding-top: 10px;
              color: black;
            }
            .barcode {
              display: block;
              margin: 10px auto;
              width: 150px;
              height: 50px;
            }
          </style>
        </head>
        <body> 
          <div class="receipt">
            <header class="header">
            ${settingData?.printingNamePrint ? `<h1>${settingData.printingName}</h1>` : ""}  
            ${settingData.printingAddressPrint ? `<p>${settingData.printingAddress}</p>` : ""}
            ${settingData.printingPhonePrint ? `<p>${settingData.printingPhone}</p>` : ""}
            
            </header>
            <section class="details">
              <div class="detailsFlex">
                <p><strong>Served By:</strong> ${userName}</p>
                <p><strong>Invoice#:</strong> ${invoiceId}</p>
              </div>
            </section>


            ${account ? `
              <section class="account">
                ${account?.english ? `
                  <div class="detailsAccount">
                    <p><strong>Customer:</strong> ${account.english}</p>
                    <p><strong>Phone:</strong> ${account?.phone}</p>
                  </div>
                  ${account.address ? `<p><strong>Customer Address:</strong> ${account?.address}</p>` : ''}
                ` : ''}
             
                ${(account?.balance || account?.newBalance) ? `
                <div class="detailsAccount">
                  ${isUsingMainCurrency ?
            `<p><strong>Balance:</strong> ${account?.balance}</p> ` : `<p><strong>Balance:</strong> ${account?.secondaryBalance}</p> `}
                  ${isUsingMainCurrency ?
            `<p><strong>newBalance:</strong> ${account?.newBalance}</p> ` : `<p><strong>newBalance:</strong> ${account?.secondaryNewBalance}</p> `}
                </div>
                ` : ''}
            
              ${journalVoucher?.paymentType ? `
              <div class="detailsAccount">
                <p><strong>Payment:</strong> ${journalVoucher?.paymentType}</p>
              </div>
            ` : ''}
              </section>
            ` : ''}


            ${delivery ? `
            <section class="details">        
                <div class="detailsFlex">
                  <p><strong>Delivery:</strong> ${delivery?.name}</p>
                  <p><strong>Phone:</strong> ${delivery?.phone}</p>
                </div>         
             </section>
               ` : ''}

            <section class="items">
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                     ${settingData.itemPricePrint ? `<th>Item</th>` : ''}
                    <th>Qty</th>
                    ${settingData.discountPrint ? `<th>Dis</th>` : ''}
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  ${cart.map((product) => `    
                    <tr>
                       <td>
                      ${settingData.categoryPrint ? `[${product.product?.category?.name}] ` : ''}  
                      ${product.name ?? product.product?.name ?? 'N/A'}
                    </td>
                      ${settingData.itemPricePrint ? `<td>${numberFormatter(product?.itemPrice)}</td>` : ''}
                      <td>x${product.netQuantity}</td>
                      ${settingData.discountPrint ? `<td>${numberFormatter(product?.priceDiscountPercentage, 2)}%</td>` : ''}
                      <td>${numberFormatter(product?.totalPrice)}</td>
                     </tr>
    ${settingData.detailsPrint && product.details ? `<tr><td colspan="5" class="td">${product.details}</td></tr>` : ''}
  `).join('')}
</tbody>
              </table>
            </section>
            <section class="summary">
              <div class="detailsFlex"><p>Discount:</p><p>${discountPercentage}%</p></div>
              <div class="detailsFlex"><p>VAT:</p><p>${numberFormatter(vatAmount)} ${currency?.symbol}</p></div>
              <div class="detailsFlex total"><p>Total:</p><p>${numberFormatter(journalVoucher?.credit) || 0} ${currency?.symbol}</p></div>
               ${settingData?.showRateOnInvoiceChange
        ? `<div class="detailsFlex"></p><p>${numberFormatter(ratedTotalPrice) || 0} ${ratedSymbol
        }</p></div>`
        : ''
      }
            </section>
            ${journalVoucher.details ? `
            <section class="details">
              <p><strong>Details:</strong> ${journalVoucher.details}</p>
            </section>
          ` : ''}

            <footer class="footer">
              <p>${moment(date || createdAt).format('MM-DD-YYYY hh:mm A')}</p>  
              ${barcodeDataUrl ? `<img src="${barcodeDataUrl}" alt="Barcode" class="barcode" />` : ''}
              <p>www.riserteam.com</p>
            </footer>
          </div>
        </body>
      </html>
    `);
  doc.close();  

  // Wait for DOM render before printing
  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 300);
  };
};

export default print;
